import React from 'react'
import classNames from 'classnames'
import { Box, FormControl, FormHelperText, InputLabel } from '@mui/material';
import ReactPhoneInput from 'react-phone-input-2';

import './styles.scss'
 
function index(props) {
    const { className, label, value, name, onBlur, helperText, onChange, error, required, maxLength } = props
    return (

        <FormControl
            variant='outlined'
            margin='normal'
            className={error ? classNames('error-border-mobile-number m-0', className) : classNames('m-0', className)}
            required={required}
            error={error && (error ? true : false)}
        >
            <InputLabel htmlFor='outlined-age-simple' className='background-white' shrink={true}>
                {label}
            </InputLabel>
            <ReactPhoneInput
                value={value}
                name={name}
                country='in'
                onChange={onChange}
                onBlur={onBlur}
                specialLabel=''
                inputProps={{
                    label: { label },
                    autoFocus: false
                }}
                inputExtraProps={{
                    margin: 'normal',
                    autoComplete: 'phone',
                    name: 'custom-username',
                    backgroundColor: 'white'
                }}
            />
            {error &&
                <FormHelperText>{error}</FormHelperText>
            }
        </FormControl>

    )
}



export default index


// <Box className={className}>
// <Box className={classNames(error ? 'text-red label' : 'label')}
// >   {label}</Box>
// <ReactPhoneInput
//     value={value}
//     name={name}
//     fullWidth
//     country='in'
//     onChange={onChange}
//     onBlur={onBlur}
//     className='phone-number'
//     inputExtraProps={{
//         margin: 'normal',
//         autoComplete: 'phone',
//         name: 'custom-username',
//     }}
// />
// <div className={error ? 'helperText-red' : 'helperText'}>
//     {helperText}
// </div>
// </Box>
